import React, { useEffect, useState } from 'react';
import {
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  FormHelperText,
} from '@mui/material';

interface FormState {
  clearDirtyWater: boolean;
  clearCleanWater: boolean;
  cleanPads: boolean;
  cleanSqueegee: boolean;
  removeDebrisFromBrush: boolean;
  topUpCleanWater: boolean;
}

interface GaussianS75MaintenanceFormProps {
  onSubmit: () => void;
}

export function GaussianS75MaintenanceForm({ onSubmit }: GaussianS75MaintenanceFormProps) {
  const [formState, setFormState] = useState<FormState>({
    clearDirtyWater: false,
    clearCleanWater: false,
    cleanPads: false,
    cleanSqueegee: false,
    removeDebrisFromBrush: false,
    topUpCleanWater: false,
  });

  const [formValid, setFormValid] = useState<boolean>(false);

  // Validation Logic
  useEffect(() => {
    // Check if all checkboxes are checked
    const isFormValid = Object.values(formState).every((value) => value);
    setFormValid(isFormValid);
  }, [formState]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  return (
    <div>
      <FormControl sx={{ m: 1 }} component="fieldset" variant="standard">
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                name="clearDirtyWater"
                checked={formState.clearDirtyWater}
                onChange={handleCheckboxChange}
              />
            }
            label="Clear Dirty Water"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="clearCleanWater"
                checked={formState.clearCleanWater}
                onChange={handleCheckboxChange}
              />
            }
            label="Clear Clean Water"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="cleanPads"
                checked={formState.cleanPads}
                onChange={handleCheckboxChange}
              />
            }
            label="Clean Pads"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="cleanSqueegee"
                checked={formState.cleanSqueegee}
                onChange={handleCheckboxChange}
              />
            }
            label="Clean Squeegee"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="removeDebrisFromBrush"
                checked={formState.removeDebrisFromBrush}
                onChange={handleCheckboxChange}
              />
            }
            label="Remove Debris from Brush"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="topUpCleanWater"
                checked={formState.topUpCleanWater}
                onChange={handleCheckboxChange}
              />
            }
            label="Top Up Clean Water"
          />
          <Button
            style={{ marginTop: 10 }}
            variant="contained"
            onClick={onSubmit}
            disabled={!formValid} // Disable the button if the form is not valid
          >
            Submit
          </Button>
        </FormGroup>
        {!formValid && (
          <FormHelperText error>You must complete all steps before submission!</FormHelperText>
        )}
      </FormControl>
    </div>
  );
}
